import { css } from "@emotion/react";
import bgShadow from "../../assets/shadow-bg.png";

export const styBrideGroom = css`
  text-align: center;
  color: #707e57;
  padding: 20px;
  background-color: #ffffff;
  background-image: url(${bgShadow});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
`;

export const styBrideWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
`;

export const styBrideWrapperFlip = css`
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
`;

export const styBrideProfile = css`
  flex-basis: 50%;

  h4 {
    color: #6b6445;
    margin: 0;
    padding: 2px 0;
    border-bottom: 0.2px solid #6b6445;

    font-size: 16px;
    font-family: "Bodoni Moda", serif;
    font-weight: 100;

    @media (min-width: 350px) {
      font-size: 20px;
    }
  }

  .child {
    font-weight: 400;
    margin: 12px 0 4px;
  }
`;

export const styBridePhoto = css`
  flex-basis: 50%;

  div {
    width: 100px;
    height: 100px;
    background: black;
    margin-left: auto;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }

    @media (min-width: 350px) {
      width: 150px;
      height: 150px;
    }
  }
`;

export const styBridePhotoFlip = css`
  flex-basis: 50%;

  div {
    width: 100px;
    height: 100px;
    background: black;
    margin-right: auto;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }

    @media (min-width: 350px) {
      width: 150px;
      height: 150px;
    }
  }
`;

export const styBrideDivider = css`
  font-size: 24px;
  font-family: "Dancing Script", cursive;
  font-weight: 700;
`;
